document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".js-split");

  targets.forEach((el) => {
    const base = parseFloat(el.dataset.delay || 0); // ← h1等の data-delay
    const text = el.textContent.trim();
    el.textContent = "";

    [...text].forEach((ch, i) => {
      const s = document.createElement("span");
      s.textContent = ch;
      s.style.setProperty("--char-index", i);
      s.style.setProperty("--delay-offset", `${base}s`); // ← これが肝
      el.appendChild(s);
    });
  });

  // 初期表示時に即座にアニメーション開始
  targets.forEach((el) => el.classList.add("is-inview"));

  // IntersectionObserver制御は一時コメントアウト
  // iOS Safari でも確実に発火するよう閾値ゆるめ＋rootMarginで底上げ
  // const io = new IntersectionObserver(
  //   (entries, observer) => {
  //     entries.forEach((entry) => {
  //       if (entry.isIntersecting) {
  //         // スタイル適用 → 次フレームでクラス付与（描画順のズレ防止）
  //         requestAnimationFrame(() => entry.target.classList.add("is-inview"));
  //         observer.unobserve(entry.target);
  //       }
  //     });
  //   },
  //   { threshold: 0.1, rootMargin: "0px 0px -10% 0px" }
  // );

  // targets.forEach((el) => io.observe(el));
});

document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(
    ".js-fadeUp, .js-slidein ,.js-fadeIn,.js-slidein-r,.js-zoomin"
  );

  const options = {
    root: null, // ビューポート
    rootMargin: "0px",
    threshold: 0.2, // 20%見えたら発火
  };

  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-show"); // ★ここで発動
        observer.unobserve(entry.target); // 一度だけでOKなら解除
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);

  targets.forEach((target) => observer.observe(target));
});
